import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { exists } from "../../utils/utils";

type CustomLoaderProps = {
  /** Is Message going to be used inside a modal? */
  isModal?: boolean;
};

class CustomLoader extends React.Component<CustomLoaderProps> {
  _renderStyle = () => {
    const style: React.CSSProperties = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    };
    if (exists(this.props.isModal) && !this.props.isModal) {
      style.height = "100vh";
    }
    return style;
  };

  render() {
    return (
      <div style={this._renderStyle()}>
        <div className="loader" />
        <Dimmer active inverted>
          <Loader size="massive">Loading...</Loader>
        </Dimmer>
      </div>
    );
  }
}
export default CustomLoader;
